import React, {useState} from 'react';
import {Redirect, useLocation} from 'react-router-dom';
import {includes} from 'lodash';

import {EARNINGS_TAB} from '../utils';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

import connectCollegeEarnings from 'shared/college-earnings/containers/college-earnings';
import CollegeEarnings from 'transfer-student/college-earnings/components/college-earnings';
import Header from './header';

const ConnectedCollegeEarnings = connectCollegeEarnings(CollegeEarnings);

const PortfolioSidebar = () => {
  const [currentTab, setCurrentTab] = useState(EARNINGS_TAB);
  const mq = useMediaQuery();
  const location = useLocation();

  if (mq.MD_AND_UP && includes(location.pathname, 'following')) {
    return <Redirect to="/portfolio" />;
  } else if (mq.MS_AND_DOWN && !includes(location.pathname, 'following')) {
    return null;
  }

  return (
    <div className="portfolio-sidebar">
      <Header key="header" currentTab={currentTab} changeTab={setCurrentTab} />
      <ConnectedCollegeEarnings />
    </div>
  );
};

export default PortfolioSidebar;
